var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeatherAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 10,
  fill: "#FF903C"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2D2D2D",
  fillRule: "evenodd",
  d: "m18.72 14.948-5.708-1.777v3.914l1.435 1.077v1.06l-2.495-.701-2.479.7v-1.06l1.402-1.076v-3.914L5.2 14.948v-1.401l5.675-3.573V6.06q0-.444.308-.752Q11.49 5 11.952 5q.461 0 .76.308.3.307.3.752v3.914l5.709 3.573z",
  clipRule: "evenodd"
})));
export default SvgWeatherAlert;